var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:`fixed-size ${_vm.classes}`,attrs:{"src":_vm.getDynamicPath(),"loading":"lazy","alt":`${_vm.name} logo`}})
}
var staticRenderFns = []

export { render, staticRenderFns }